var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 15.5V14.5C12.8337 13.0999 12.8337 12.3998 12.5612 11.865C12.3215 11.3946 11.939 11.0122 11.4686 10.7725C10.9339 10.5 10.2338 10.5 8.83366 10.5H5.16699C3.76686 10.5 3.0668 10.5 2.53202 10.7725C2.06161 11.0122 1.67916 11.3946 1.43948 11.865C1.16699 12.3998 1.16699 13.0999 1.16699 14.5V15.5M12.8337 3L14.5003 4.66667L17.8337 1.33334M9.91699 4.25C9.91699 5.86083 8.61116 7.16667 7.00033 7.16667C5.3895 7.16667 4.08366 5.86083 4.08366 4.25C4.08366 2.63917 5.3895 1.33334 7.00033 1.33334C8.61116 1.33334 9.91699 2.63917 9.91699 4.25Z",
    stroke: "#079455",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseApproval);
export default __webpack_public_path__ + "static/media/expense-approval.4e2e2d8d72a26c52c2544729b8f0036c.svg";
export { ForwardRef as ReactComponent };